// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum DimensionValueType {
  UNKNOWN = 0,
  VALUE = 1,
  PARAM = 2,
}
